module.exports = __webpack_public_path__ + "static/img/1.463d03d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/zh/1.png
// module id = XTJX
// module chunks = 0